import React from 'react';

// Месячный календарь в модалке. Аналог react-native-calendars из мобильного
// `client_app/.../Cart/Checkout` (BottomModalWrapper + Calendar).
// Управляется через props, без подписок на стор.
//
// Props:
//   value     — выбранная дата ISO `YYYY-MM-DD` или пусто.
//   minDate   — нижняя граница ISO (orderStore.minDateForOrder); раньше — нельзя.
//   onPick(iso) — клик по доступному дню. Родитель сам закрывает диалог.
//   onClose() — клик по ×/overlay.

const MONTH_NAMES = [
  'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
  'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь',
];
const DOW_SHORT = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

function pad2(n) { return (n < 10 ? '0' : '') + n; }
function toIso(y, m, d) { return y + '-' + pad2(m + 1) + '-' + pad2(d); }

function parseIso(str) {
  if (!str || typeof str !== 'string') return null;
  const m = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  return { y: +m[1], m: +m[2] - 1, d: +m[3] };
}

function daysInMonth(y, m) { return new Date(y, m + 1, 0).getDate(); }

// 0=Пн, ..., 6=Вс — мобильный firstDay=1.
function firstWeekdayMon(y, m) {
  const jsDow = new Date(y, m, 1).getDay(); // 0=Вс..6=Сб
  return (jsDow + 6) % 7;
}

export class DatePickerDialog extends React.Component {
  constructor(props) {
    super(props);
    const seed = parseIso(props.value) || parseIso(props.minDate) || (() => {
      const d = new Date();
      return { y: d.getFullYear(), m: d.getMonth(), d: d.getDate() };
    })();
    this.state = { viewYear: seed.y, viewMonth: seed.m };
  }

  prevMonth = () => {
    if (this.prevDisabled()) return;
    let { viewYear, viewMonth } = this.state;
    viewMonth -= 1;
    if (viewMonth < 0) { viewMonth = 11; viewYear -= 1; }
    this.setState({ viewYear, viewMonth });
  };

  nextMonth = () => {
    let { viewYear, viewMonth } = this.state;
    viewMonth += 1;
    if (viewMonth > 11) { viewMonth = 0; viewYear += 1; }
    this.setState({ viewYear, viewMonth });
  };

  prevDisabled() {
    const min = this.props.minDate;
    if (!min) return false;
    const { viewYear, viewMonth } = this.state;
    let prevY = viewYear, prevM = viewMonth - 1;
    if (prevM < 0) { prevM = 11; prevY -= 1; }
    const lastIso = toIso(prevY, prevM, daysInMonth(prevY, prevM));
    return lastIso < min;
  }

  pickDay = (iso, disabled) => {
    if (disabled) return;
    if (this.props.onPick) this.props.onPick(iso);
  };

  renderGrid() {
    const { viewYear, viewMonth } = this.state;
    const min = this.props.minDate || '';
    const selected = this.props.value || '';
    const today = (() => {
      const d = new Date();
      return toIso(d.getFullYear(), d.getMonth(), d.getDate());
    })();

    const total = daysInMonth(viewYear, viewMonth);
    const firstWd = firstWeekdayMon(viewYear, viewMonth);

    const cells = [];
    for (let i = 0; i < firstWd; i += 1) {
      cells.push(
        <div key={'e' + i} className="ng-datepicker__day ng-datepicker__day--empty" />
      );
    }
    for (let d = 1; d <= total; d += 1) {
      const iso = toIso(viewYear, viewMonth, d);
      const disabled = min ? iso < min : false;
      const isSelected = iso === selected;
      const isToday = iso === today;
      const cls = ['ng-datepicker__day'];
      if (isSelected) cls.push('ng-datepicker__day--selected');
      if (disabled) cls.push('ng-datepicker__day--disabled');
      if (isToday && !isSelected) cls.push('ng-datepicker__day--today');
      cells.push(
        <button
          key={iso}
          type="button"
          className={cls.join(' ')}
          disabled={disabled}
          onClick={() => this.pickDay(iso, disabled)}
        >
          {d}
        </button>
      );
    }
    return cells;
  }

  render() {
    const { viewYear, viewMonth } = this.state;
    const prevDisabled = this.prevDisabled();

    return (
      <div className="dialog">
        <div className="dialog__bg" onClick={this.props.onClose} />
        <div className="dialog__content">
          <div className="dialog__close" onClick={this.props.onClose} />
          <div className="ng-datepicker">
            <div className="ng-datepicker__head">
              <button
                type="button"
                className="ng-datepicker__nav"
                onClick={this.prevMonth}
                disabled={prevDisabled}
                aria-label="Предыдущий месяц"
              >‹</button>
              <div className="ng-datepicker__title">
                {MONTH_NAMES[viewMonth]} {viewYear}
              </div>
              <button
                type="button"
                className="ng-datepicker__nav"
                onClick={this.nextMonth}
                aria-label="Следующий месяц"
              >›</button>
            </div>
            <div className="ng-datepicker__grid">
              {DOW_SHORT.map((d) => (
                <div key={d} className="ng-datepicker__dow">{d}</div>
              ))}
              {this.renderGrid()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Cart/Checkout/DatePickerDialog.jsx